import { render, staticRenderFns } from "./SitesNav.vue?vue&type=template&id=66a8a0f8&"
import script from "./SitesNav.vue?vue&type=script&lang=ts&"
export * from "./SitesNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports